import { useEffect, useRef } from 'react';

function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { el.classList.add('visible'); obs.unobserve(el); } },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

const stats = [
  { value: '3+', label: 'Years Home Inspector', icon: 'ri-search-eye-line' },
  { value: '100+', label: 'Clients Helped', icon: 'ri-team-line' },
  { value: '9', label: 'Counties Served', icon: 'ri-map-pin-2-line' },
  { value: '5★', label: 'Client Reviews', icon: 'ri-star-fill' },
];

export default function HomeStats() {
  const ref = useReveal();
  return (
    <section className="bg-white border-b border-gray-100">
      <div ref={ref} className="reveal max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 py-8 sm:py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-gray-100 rounded-lg overflow-hidden">
          {stats.map((s, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-center py-6 sm:py-8 px-3 sm:px-4 text-center bg-white"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className={`${s.icon} text-2xl text-[#C8923A]`}></i>
              </div>
              <p className="font-cormorant text-3xl sm:text-4xl font-semibold text-[#111111] leading-none mb-1">{s.value}</p>
              <p className="text-xs text-[#888] uppercase tracking-wider mt-1 leading-tight">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
